import DacDiemLienQuanBenh from './DacDiemLienQuanBenh';
import HoSoPhimAnh from './HoSoPhimAnh';
import ThongTinSinhHieu from './ThongTinSinhHieu';
import TomTatKetQuaCanLamSang from './TomTatKetQuaCanLamSang';
import XetNghiemCanLamSang from './XetNghiemCanLamSang';
import {usePhanHeKhamBenhContext} from "src/app/modules/phan-he-kham-benh/contexts/PhanHeTiepDonContext";

interface Props {
	data: any;
}

const CustomComponent = ({ data }: Props) => {
  const {benhNhanInfo} = usePhanHeKhamBenhContext();
  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

	const Default = () => {
		return <></>;
	};

	const components: { [key: string]: any } = {
		dacDiemLienQuanBenh: DacDiemLienQuanBenh,
		thongTinSinhHieu: ThongTinSinhHieu,
		xetNghiemCanLamSang: XetNghiemCanLamSang,
		tomTatKetQuaCanLamSang: TomTatKetQuaCanLamSang,
		hoSoPhimAnh: HoSoPhimAnh,
	};

	const params = {
		patientInfo: benhNhanDieuTri
	};

	const DynamicContent = components[data?.componentName] || Default;
	
	return <DynamicContent {...data} {...params} />;
};

export default CustomComponent;
